<template>
  <!-- 组合商品 -->
  <div class="group">
    <!-- 面包屑导航 -->
    <crumbs-bar :crumbsList="['促销管理',$route.meta.title]">
    </crumbs-bar>
    <el-scrollbar style="height:(100% - 40px);padding-top:20px;box-sizing:border-box">
      <el-form :model="addForm" label-position="right"
        label-width="120px" ref="addForm" :rules="addFormRule">
        <div class="form-item-wrap">
          <el-form-item label="方案名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入方案名称" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="方案类型" prop="type">
            <el-select v-model="addForm.type" placeholder="请选择" style="width:200px;">
              <el-option label="商品组合" value="GZH"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="clientType">
            <el-select v-model="addForm.clientType" placeholder="请选择" style="width:200px;">
              <el-option label="全部" value="All"></el-option>
              <el-option label="终端" value="F001"></el-option>
              <el-option label="批发" value="F002"></el-option>
              <el-option label="连锁" value="F003"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="促销描述" prop="des">
            <el-input v-model="addForm.des" placeholder="促销描述" style="width:200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="促销数量" prop="sum">
            <el-input-number v-model="addForm.sum" :min="1" style="width:200px;"></el-input-number>
          </el-form-item>
          <el-form-item label="限购数量" prop="limit">
            <el-input-number v-model="addForm.limit" :min="1" style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              v-model="addForm.startTime"
              style="width:200px;"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              v-model="addForm.endTime"
              style="width:200px;"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="是否显示" prop="isShow">
            <el-checkbox v-model="addForm.isShow">
              <span v-show="addForm.isShow">显  示</span>
              <span v-show="!addForm.isShow">不显示</span>
            </el-checkbox>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="">
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button type="info" @click="clearForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js"

export default {
  name: 'group',
  data() {
    return {
      /**表单信息 */
      addForm: {
        name: '', // 方案名称
        type: 'GZH', // 方案类型
        clientType: 'All', // 客户类型
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        isShow: true, // 是否显示
        sum: 1, // 促销总数
        limit: 1, // 限购数量
        des: '' // 促销描述
      },
      /**表单规则 */
      addFormRule: {
        name: [ mustFill ],
        type: [ mustFill ],
        clientType: [ mustFill ],
        startTime: [ mustFill ],
        endTime: [ mustFill ],
        sum: [ mustFill ],
        limit: [ mustFill ],
      }
    }
  },
  components: {
  },
  methods:{
    /**关闭drawer 清空表单信息 */
    clearForm(){
      this.addForm = {
        name: '', // 方案名称
        type: 'GZH', // 方案类型
        clientType: 'All', // 客户类型
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        isShow: true, // 是否显示
        sum: 1, // 促销总数
        limit: 1, // 限购数量
        des: '' // 促销描述
      }
    },
    /**提交表单 */
    submit(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let data = {
            type: "SaveProm",
            faname: this.addForm.name,
            ruleCode: this.addForm.id,
            faType: this.addForm.type,
            customerType: this.addForm.clientType,
            describe: this.addForm.des,
            Quantity: this.addForm.allNum,
            xgAmount: this.addForm.limitNum,
            lsid: '',
          }
          this.$requestSys({
            method: "post",
            url: "prom/ashx/PromGroupRule.ashx?json=" + encodeURIComponent(JSON.stringify(data)),
          }).then((res) => {
            if(res.flag == 0){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              // this.goBack()
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          }).catch((err) => {
            window.console.log(err)
          })
        }else{
          this.$message({
            message: '请补全信息',
            type: 'warning'
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.group{
  width: 100%;
  height: 100%;
}
.form-item-wrap{
  display: flex;
  padding: 0 0 0 20px;
  box-sizing: border-box;
}
</style>
